import { searchForBlogs } from './storefront-graphql-helper.js'
const searchBar = document.getElementById('blog-search-bar');
const searchSuggestionContainer = document.querySelector('.bs-suggestions-container')

  // Debounce function
  function debounce(callback, delay) {
      let timeoutId
      return function() {
          clearTimeout(timeoutId)
          timeoutId = setTimeout(() => {
              callback.apply(this, arguments)
          }, delay)
      }
  }

  // Responsible for checking if the instant search suggestion should be visible or not
  const isInputInFocus = () => {
    const focusedElement = document.activeElement;
    if (focusedElement !== searchBar) {
      searchSuggestionContainer.style.visibility = "hidden"
    }
  }
  window.addEventListener('click', isInputInFocus);

  const buildSuggestions = (suggestions) => {
    const cleanSuggestions = suggestions.search.edges
    let suggestionHTML = ''
    if (cleanSuggestions.length) {
      cleanSuggestions.forEach(suggestion => {
        const html = `
        <div class="bs-suggestion">
        <a href="${suggestion.node.onlineStoreUrl}" class="bs-suggestion">${suggestion.node.title}</a>
        </div>
        `
        suggestionHTML += html
      })
      searchSuggestionContainer.innerHTML = suggestionHTML
      searchSuggestionContainer.style.visibility = "visible"
    } else {
      const html = `
      <div class="bs-suggestion">No results found, please try another search term.</div>
      `
      searchSuggestionContainer.innerHTML = html
      searchSuggestionContainer.style.visibility = "visible"
    }
  }

  const getSearchInput = async () => {
    const inputValue = searchBar.value
    if (inputValue.length >= 3) {
      const searchData = await searchForBlogs(inputValue)
      buildSuggestions(searchData)
    }
  }

// Listening to search input and starting all the functions
searchBar.addEventListener('input', debounce(getSearchInput, 300))

// need to manually direct the url because if there is an action in the form the url will keep doubling up
document.getElementById('searchForm').addEventListener('submit', function (event) {
  event.preventDefault()
  const queryParamExists = window.location.href.includes('all/article-search')
  this.action = `${window.routes.secure_url}/blogs/all/article-search`
  this.submit()
});

// Need to also check for the search icon
document.getElementById('searchIcon').addEventListener('click', function () {
  const searchInput = document.getElementById('blog-search-bar')
  if (searchInput.value.trim().length >= 3) {
    document.getElementById('searchForm').submit()
  }
});